import { useState } from "react";
import { uploadLogo } from "../../api/uploadService";

export const useUploadLogo = (successCallback) => {
  const [progress, setProgress] = useState(0);

  const upload = async (data) => {
    try {
      const newFile = await uploadLogo(data, setProgress);
      successCallback();
      setProgress(0); // reset after success
      return newFile;
    } catch (error) {
      console.error("Failed to upload file:", error);
      setProgress(0); // reset on error
      throw error;
    }
  };

  return { upload, progress };
};